import React from "react";

export default function TermAndCondition({ paddingBottom = 50 }) {
  return (
    <div
      style={{
        paddingBottom,
      }}
    >
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(\'https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98\');.lst-kix_list_5-1>li{counter-increment:lst-ctn-kix_list_5-1}.lst-kix_list_2-1>li{counter-increment:lst-ctn-kix_list_2-1}.lst-kix_list_1-1>li{counter-increment:lst-ctn-kix_list_1-1}ol.lst-kix_list_2-6.start{counter-reset:lst-ctn-kix_list_2-6 0}.lst-kix_list_3-0>li:before{content:"\\0025cf  "}.lst-kix_list_3-1>li:before{content:"o  "}.lst-kix_list_3-2>li:before{content:"\\0025aa  "}ol.lst-kix_list_1-8.start{counter-reset:lst-ctn-kix_list_1-8 0}.lst-kix_list_4-0>li{counter-increment:lst-ctn-kix_list_4-0}.lst-kix_list_5-0>li{counter-increment:lst-ctn-kix_list_5-0}ol.lst-kix_list_2-3.start{counter-reset:lst-ctn-kix_list_2-3 0}.lst-kix_list_3-5>li:before{content:"\\0025aa  "}.lst-kix_list_3-4>li:before{content:"o  "}ol.lst-kix_list_1-5.start{counter-reset:lst-ctn-kix_list_1-5 0}.lst-kix_list_3-3>li:before{content:"\\0025cf  "}.lst-kix_list_3-8>li:before{content:"\\0025aa  "}.lst-kix_list_2-0>li{counter-increment:lst-ctn-kix_list_2-0}ol.lst-kix_list_5-3.start{counter-reset:lst-ctn-kix_list_5-3 0}.lst-kix_list_2-3>li{counter-increment:lst-ctn-kix_list_2-3}.lst-kix_list_3-6>li:before{content:"\\0025cf  "}.lst-kix_list_3-7>li:before{content:"o  "}ol.lst-kix_list_5-0.start{counter-reset:lst-ctn-kix_list_5-0 0}.lst-kix_list_1-2>li{counter-increment:lst-ctn-kix_list_1-2}.lst-kix_list_5-2>li{counter-increment:lst-ctn-kix_list_5-2}ol.lst-kix_list_2-2{list-style-type:none}ol.lst-kix_list_2-3{list-style-type:none}.lst-kix_list_5-0>li:before{content:"" counter(lst-ctn-kix_list_5-0,decimal) ". "}ol.lst-kix_list_2-4{list-style-type:none}ol.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_5-4>li{counter-increment:lst-ctn-kix_list_5-4}.lst-kix_list_1-4>li{counter-increment:lst-ctn-kix_list_1-4}ol.lst-kix_list_2-0{list-style-type:none}ol.lst-kix_list_1-6.start{counter-reset:lst-ctn-kix_list_1-6 0}ol.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_4-8>li:before{content:"\\0025aa  "}.lst-kix_list_5-3>li:before{content:"" counter(lst-ctn-kix_list_5-3,decimal) ". "}.lst-kix_list_4-7>li:before{content:"o  "}.lst-kix_list_5-2>li:before{content:"" counter(lst-ctn-kix_list_5-2,lower-roman) ". "}.lst-kix_list_5-1>li:before{content:"" counter(lst-ctn-kix_list_5-1,lower-latin) ". "}li.li-bullet-6:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_5-7>li:before{content:"" counter(lst-ctn-kix_list_5-7,lower-latin) ". "}ol.lst-kix_list_5-6.start{counter-reset:lst-ctn-kix_list_5-6 0}ul.lst-kix_list_4-6{list-style-type:none}.lst-kix_list_5-6>li:before{content:"" counter(lst-ctn-kix_list_5-6,decimal) ". "}.lst-kix_list_5-8>li:before{content:"" counter(lst-ctn-kix_list_5-8,lower-roman) ". "}ul.lst-kix_list_4-7{list-style-type:none}ul.lst-kix_list_4-1{list-style-type:none}.lst-kix_list_5-4>li:before{content:"" counter(lst-ctn-kix_list_5-4,lower-latin) ". "}ul.lst-kix_list_4-4{list-style-type:none}.lst-kix_list_5-5>li:before{content:"" counter(lst-ctn-kix_list_5-5,lower-roman) ". "}ol.lst-kix_list_2-6{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ol.lst-kix_list_2-7{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ol.lst-kix_list_2-8{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}ol.lst-kix_list_1-0.start{counter-reset:lst-ctn-kix_list_1-0 0}ol.lst-kix_list_4-0.start{counter-reset:lst-ctn-kix_list_4-0 0}li.li-bullet-2:before{margin-left:-25.2pt;white-space:nowrap;display:inline-block;min-width:25.2pt}.lst-kix_list_2-5>li{counter-increment:lst-ctn-kix_list_2-5}.lst-kix_list_2-8>li{counter-increment:lst-ctn-kix_list_2-8}ol.lst-kix_list_5-5.start{counter-reset:lst-ctn-kix_list_5-5 0}.lst-kix_list_2-2>li{counter-increment:lst-ctn-kix_list_2-2}ol.lst-kix_list_2-4.start{counter-reset:lst-ctn-kix_list_2-4 0}ol.lst-kix_list_1-3{list-style-type:none}ol.lst-kix_list_5-0{list-style-type:none}ol.lst-kix_list_1-4{list-style-type:none}.lst-kix_list_2-6>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) ". "}.lst-kix_list_2-7>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) "." counter(lst-ctn-kix_list_2-7,decimal) ". "}.lst-kix_list_2-7>li{counter-increment:lst-ctn-kix_list_2-7}ol.lst-kix_list_5-1{list-style-type:none}ol.lst-kix_list_1-5{list-style-type:none}ol.lst-kix_list_5-2{list-style-type:none}ol.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_1-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) ". "}.lst-kix_list_2-5>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) ". "}.lst-kix_list_2-8>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) "." counter(lst-ctn-kix_list_2-7,decimal) "." counter(lst-ctn-kix_list_2-8,decimal) ". "}ol.lst-kix_list_1-1{list-style-type:none}ol.lst-kix_list_1-2{list-style-type:none}ol.lst-kix_list_5-4.start{counter-reset:lst-ctn-kix_list_5-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}ol.lst-kix_list_5-1.start{counter-reset:lst-ctn-kix_list_5-1 0}ol.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_3-1{list-style-type:none}ol.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_5-7>li{counter-increment:lst-ctn-kix_list_5-7}ul.lst-kix_list_3-0{list-style-type:none}ol.lst-kix_list_5-3{list-style-type:none}ol.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ol.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_1-7>li{counter-increment:lst-ctn-kix_list_1-7}ol.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ol.lst-kix_list_5-5{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ol.lst-kix_list_5-6{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}ol.lst-kix_list_2-5.start{counter-reset:lst-ctn-kix_list_2-5 0}.lst-kix_list_5-8>li{counter-increment:lst-ctn-kix_list_5-8}li.li-bullet-1:before{margin-left:-21.6pt;white-space:nowrap;display:inline-block;min-width:21.6pt}.lst-kix_list_4-0>li:before{content:"" counter(lst-ctn-kix_list_4-0,lower-latin) ") "}.lst-kix_list_2-6>li{counter-increment:lst-ctn-kix_list_2-6}.lst-kix_list_4-1>li:before{content:"o  "}li.li-bullet-3:before{margin-left:-25.2pt;white-space:nowrap;display:inline-block;min-width:25.2pt}ol.lst-kix_list_1-7.start{counter-reset:lst-ctn-kix_list_1-7 0}.lst-kix_list_4-4>li:before{content:"o  "}ol.lst-kix_list_2-2.start{counter-reset:lst-ctn-kix_list_2-2 0}.lst-kix_list_1-5>li{counter-increment:lst-ctn-kix_list_1-5}.lst-kix_list_4-3>li:before{content:"\\0025cf  "}.lst-kix_list_4-5>li:before{content:"\\0025aa  "}.lst-kix_list_4-2>li:before{content:"\\0025aa  "}.lst-kix_list_4-6>li:before{content:"\\0025cf  "}ol.lst-kix_list_5-7.start{counter-reset:lst-ctn-kix_list_5-7 0}.lst-kix_list_1-8>li{counter-increment:lst-ctn-kix_list_1-8}ol.lst-kix_list_1-4.start{counter-reset:lst-ctn-kix_list_1-4 0}.lst-kix_list_5-5>li{counter-increment:lst-ctn-kix_list_5-5}ol.lst-kix_list_1-1.start{counter-reset:lst-ctn-kix_list_1-1 0}ol.lst-kix_list_4-0{list-style-type:none}.lst-kix_list_2-4>li{counter-increment:lst-ctn-kix_list_2-4}li.li-bullet-5:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_list_5-3>li{counter-increment:lst-ctn-kix_list_5-3}ol.lst-kix_list_1-3.start{counter-reset:lst-ctn-kix_list_1-3 0}ol.lst-kix_list_2-8.start{counter-reset:lst-ctn-kix_list_2-8 0}ol.lst-kix_list_1-2.start{counter-reset:lst-ctn-kix_list_1-2 0}.lst-kix_list_1-0>li:before{content:"" counter(lst-ctn-kix_list_1-0,decimal) ". "}.lst-kix_list_1-1>li:before{content:"" counter(lst-ctn-kix_list_1-1,lower-latin) ". "}.lst-kix_list_1-2>li:before{content:"" counter(lst-ctn-kix_list_1-2,lower-roman) ". "}ol.lst-kix_list_2-0.start{counter-reset:lst-ctn-kix_list_2-0 0}.lst-kix_list_1-3>li:before{content:"" counter(lst-ctn-kix_list_1-3,decimal) ". "}.lst-kix_list_1-4>li:before{content:"" counter(lst-ctn-kix_list_1-4,lower-latin) ". "}.lst-kix_list_1-0>li{counter-increment:lst-ctn-kix_list_1-0}.lst-kix_list_1-6>li{counter-increment:lst-ctn-kix_list_1-6}.lst-kix_list_1-7>li:before{content:"" counter(lst-ctn-kix_list_1-7,lower-latin) ". "}ol.lst-kix_list_5-8.start{counter-reset:lst-ctn-kix_list_5-8 0}ol.lst-kix_list_2-7.start{counter-reset:lst-ctn-kix_list_2-7 0}.lst-kix_list_1-3>li{counter-increment:lst-ctn-kix_list_1-3}.lst-kix_list_1-5>li:before{content:"" counter(lst-ctn-kix_list_1-5,lower-roman) ". "}.lst-kix_list_1-6>li:before{content:"" counter(lst-ctn-kix_list_1-6,decimal) ". "}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}li.li-bullet-4:before{margin-left:-25.2pt;white-space:nowrap;display:inline-block;min-width:25.2pt}.lst-kix_list_5-6>li{counter-increment:lst-ctn-kix_list_5-6}.lst-kix_list_2-0>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) ". "}.lst-kix_list_2-1>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) ". "}ol.lst-kix_list_2-1.start{counter-reset:lst-ctn-kix_list_2-1 0}.lst-kix_list_1-8>li:before{content:"" counter(lst-ctn-kix_list_1-8,lower-roman) ". "}.lst-kix_list_2-2>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) ". "}.lst-kix_list_2-3>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) ". "}ol.lst-kix_list_5-2.start{counter-reset:lst-ctn-kix_list_5-2 0}ol{margin:0;padding:0}table td,table th{padding:0}.c3{margin-left:18pt;padding-top:0pt;text-indent:-18pt;padding-bottom:8pt;line-height:1.5;orphans:2;widows:2;text-align:left;height:11pt}.c19{-webkit-text-decoration-skip:none;color:#000000;font-weight:700;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:14pt;font-family:"Arial";font-style:normal}.c7{margin-left:36pt;padding-top:0pt;padding-left:3.6pt;padding-bottom:8pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c0{margin-left:53.5pt;padding-top:0pt;padding-left:7.2pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c4{margin-left:36pt;padding-top:0pt;padding-left:3.6pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c5{margin-left:18pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c10{margin-left:60.5pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c2{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Arial";font-style:normal}.c13{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Arial";font-style:normal}.c12{padding-top:0pt;padding-bottom:8pt;line-height:1.5;orphans:2;widows:2;text-align:center}.c8{padding-top:0pt;padding-bottom:8pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c17{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:right}.c16{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c14{font-size:12pt;font-family:"Arial";color:#000000;font-weight:400;text-decoration:none}.c18{font-size:12pt;font-family:"Arial";font-weight:400}.c9{background-color:#ffffff;max-width:451.3pt;padding:72pt 72pt 72pt 72pt}.c15{color:inherit;text-decoration:inherit}.c6{padding:0;margin:0}.c11{height:11pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.0791666666666666;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Calibri"}p{margin:0;color:#000000;font-size:11pt;font-family:"Calibri"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:14pt;color:#000000;font-weight:700;font-size:14pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}',
        }}
      />
      <div>
        <p className="c11 c16">
          <span className="c13" />
        </p>
      </div>
      <p className="c12">
        <span className="c19">TERMS AND CONDITIONS</span>
      </p>
      <p className="c8">
        <span className="c1">Last updated date: January 19, 2024.</span>
      </p>
      <p className="c8">
        <span className="c1">
          Important Message: Please carefully review these Terms of Use
          ("Terms", "Terms of Use", or "Agreement") before using this online or
          mobile entertainment service, as they have legal implications that
          affect your rights and obligations, including waivers of rights,
          limitation of liability, and your obligation to indemnify us. This
          Agreement mandates the use of arbitration on an individual basis to
          resolve disputes, rather than courts, jury trials, or class actions,
          and restricts the remedies available in case of a dispute.{" "}
        </span>
      </p>
      <p className="c8">
        <span className="c18">
          This Agreement (“Agreement”) is entered between - Qunions Studios
          having its registered office at 90 Jagannath Puri, Mathura, UP –
          281001, through its website{" "}
        </span>
        <span className="c14">
          <a
            className="c15"
            href="https://www.google.com/url?q=http://www.qunions.com&sa=D&source=editors&ust=1682035018956425&usg=AOvVaw2TO5gCr49vUwcJF3zUO4A8"
          >
            www.qunions.com
          </a>
        </span>
        <span className="c1">
          , and ‘You’ as the User on the website. The terms such as ‘Company’,
          ‘Platform’, and ‘Qunions’ shall be used in reference to the Platform,
          and the terms such as ‘You’, ‘User’, and ‘End User’ shall be used in
          reference to the User of the website.
        </span>
      </p>
      <p className="c8">
        <span className="c2">
          NOW, THEREFORE, IN CONSIDERATION OF THE PROMISES AND MUTUAL COVENANTS
          SET FORTH HEREIN, THE PARTIES HERETO, INTENDING TO BE LEGALLY BOUND,
          HEREBY AGREE AS FOLLOWS:
        </span>
      </p>
      <p className="c3">
        <span className="c1" />
      </p>
      <ol className="c6 lst-kix_list_2-0 start" start={1}>
        <li className="c5 li-bullet-0">
          <span className="c2">ACCEPTANCE:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            In order to use the Services, you must first agree to the Terms. If
            you do not agree to the Terms, you are not allowed to use the
            Services. You can accept the Terms by:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Clicking to accept or agree to the Terms where this option is
            provided in the user interface for any Service, or
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">Using the Services.</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1" start={2}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            By continuing to use the Services, you understand and agree that
            Qunions will consider your continued use of the Services as
            acceptance of the Terms. However, you may not use the Services or
            accept the Terms if:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-4">
          <span className="c1">
            You are not of legal age to form a binding contract with Qunions, or
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            You are a person prohibited from receiving the Services under the
            laws of India or any other country, including the country where you
            reside or use the Services. Before proceeding, it is recommended to
            print or save a local copy of the Qunions Terms for your records.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={2}>
        <li className="c5 li-bullet-0">
          <span className="c2">PARTICIPATION:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            All transactions on the platform are conducted in a{" "}
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              virtual currency environment
            </span>
            , with the platform using "Rewards balance" as a term for their
            local virtual currency. When engaging in opinion trading on
            post-event analysis/discussions, users do not risk losing real
            money. Eligible rewards balance recharges are free, and real money
            gift cards can be obtained using rewards money at different
            milestones, with varying exchange rates between 1% and 10% . By
            using the platform, users acknowledge and agree to participate in a
            virtual currency environment to win real money gift cards.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            User agrees to comply by the official rules of contests explained
            below. These rules can also be referred to any time within the App
            in the "How to Play" section in the settings menu, "Get ready to
            Play and Win" section on the Home page, "Help" (bulb icon) icon on
            the top right hand side of the home page, "Weekly League Rules" in
            the Weekly League section, and within any contest in "How to Play"
            section.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions reserves the right to distribute and analyze the redemption
            of gift cards in a fair manner. Any misconduct, including but not
            limited to creating multiple accounts by a single user, not abiding
            by FairPlay policies, exploiting app features unfairly, or engaging
            in other prohibited activities, may result in the revocation of
            eligibility to avail real money gift cards. Users acknowledge and
            agree to these terms.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            In any and all contests, Apple is not a sponsor in any shape or
            form.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            In any and all contests, Google is not a sponsor in any shape or
            form.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions provides users with a platform to trade opinions on
            post-event analysis and discussions. On the platform, there are only
            opinions to a question and no single factual correct answer. Users
            acknowledge this fact and cannot claim any particular option as a
            correct answer.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c2">Qunions "Open Trades"</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-3">
          <span className="c1">
            For all trade questions, there are multiple opinion-based options.
            Users can invest in any option within a minimum and maximum range
            for that trade. Two out of all options in any/all trades are winning
            options. The option that receives the most votes is the "Majority"
            category winning option, and the option that receives the least
            votes is the "Minority" category winning option. All investments on
            the winning options yield returns based on their respective winning
            category's final return percentage. All other investments that are
            not on the winning options yield no returns. Users understand and
            accept the platform's methodology of winning and not winning a
            trade.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Until a trade is closed, the winning return percentage for that
            trade on either of the winning categories may change as more users
            enter the trade or existing users edit their responses. The platform
            allows for response editing before the close of a trade. Once a
            trade is closed, the last response to that trade is considered
            final. Users understand and accept the trade-off between the
            variability of "winning returns" and the flexibility of "editing the
            response" as part of the overall experience.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Winning return percentages on either of the winning categories are
            calculated and displayed in real time on the App using Qunions'
            proprietary algorithm. This algorithm quantifies the difficulty of
            identifying the winning category (Majority or Minority) in the
            population. Higher difficulty corresponds to lower separability and
            higher returns. Users understand and accept the platform's criteria
            for redistributing all investments on a trade between the winning
            options as per the platform's algorithm.
          </span>
        </li>
        <li className="c0 li-bullet-4">
          <span className="c1">
            Although the winning return percentages are calculated in real time,
            they are published on the App with some time lag and controlled
            frequency. The time lag and publication frequency control measures
            are in place to provide a smoother user experience. Users
            acknowledge this fact in support of a better overall user
            experience.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Once a user has entered a trade, they cannot withdraw from it.
            However, they can edit their response, including changing or
            minimizing their investment, any number of times before the close of
            the trade.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Qunions reserves the right to abandon any trade question or any of
            the options, or adjust the deadline for the close of a trade in
            certain unforeseen circumstances. The platform will notify users of
            any changes, and all investments will be reversed accordingly.
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Investing in certain trades may be subject to specific rules that
            will be notified to users by Qunions for that trade. These rules
            will be in addition to the Terms and Conditions.
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Users have the option to visit and analyze the archived trades in
            order to understand the psychology of the population and formulate
            their own strategies for active trades. However, the platform does
            not assume any responsibility for any correlation or causation, or
            lack thereof, between archived trades and active trades.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1" start={5}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            All users acknowledge and understand that participation on the
            Qunions Platform in various formats is based on their individual
            analysis of winning objectives and their perception of the overall
            population's opinion/strategy. Such analysis may or may not
            correlate with actual facts or the actual opinion of the population.
            Qunions does not assume any responsibility for any correlation or
            lack thereof between any independent population survey and Qunions'
            statistics.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c2">Qunions "Live Game"</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Live games on the Qunions platform are private events to be
            conducted within a user's own group. All users must invite or
            participate within their known acquaintances and should not spam
            unknown individuals without their consent.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            The user assumes full responsibility for extending invitations to
            others to join their group or for participating in another user's
            group. Any experiences, events, or activities related to private
            groups, including but not limited to interactions among group
            members, decisions made within the group, and any outcomes or
            consequences arising from such interactions or decisions, are solely
            between the user and their host. Qunions shall not be held
            responsible or liable for any actions, omissions, or consequences
            related to private groups on the Qunions platform, including but not
            limited to any disputes, conflicts, losses, damages, or claims
            arising from or in connection with the user's participation in or
            interaction with private groups.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={3}>
        <li className="c5 li-bullet-0">
          <span className="c2">USER CONDUCT: </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Respectful Communication: Users are expected to communicate with
            each other in a respectful and courteous manner. Any form of
            abusive, offensive, or discriminatory language or behavior towards
            other users will not be tolerated.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Appropriate Content: Users are responsible for the content they post
            on the app, including questions, opinions, and comments. Content
            that is illegal, obscene, defamatory, threatening, or promotes
            violence, discrimination, or harassment of any kind is strictly
            prohibited.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Privacy and Confidentiality: Users must respect the privacy and
            confidentiality of other users. Sharing the personal information of
            other users without their consent is strictly prohibited. Users
            should also refrain from discussing or sharing any confidential
            information related to the virtual trading platform or virtual money
            fantasy events.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Fair Play: Users should engage in fair play while participating in
            the virtual trading platform and virtual money fantasy events. Any
            form of cheating, manipulation, or exploitation of app features or
            other users is strictly prohibited. Users are expected to adhere to
            the rules and guidelines of the app and the specific events they are
            participating in.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            No Spamming or Advertising: Users should refrain from spamming or
            promoting any form of advertising, including self-promotion or
            third-party promotion, on the app. Users should also avoid excessive
            posting or repetitive content that disrupts the user experience of
            others.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Respect Intellectual Property: Users should not engage in any
            activities that violate intellectual property rights, including
            copyrights, trademarks, patents, or trade secrets. Users should not
            upload or share any content that infringes upon the intellectual
            property rights of others.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Reporting of Violations: Users are encouraged to report any
            violations of the user conduct guidelines or any other suspicious or
            inappropriate activities on the app to the app administrators or
            moderators. This will help in maintaining a safe and enjoyable
            environment for all users.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Compliance with Laws: Users must comply with all applicable laws and
            regulations while using the app. Any activities that are illegal,
            fraudulent, or violate any local, national, or international laws
            are strictly prohibited.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Users agree not to use Qunions for any of the following:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Obscene, offensive, indecent, racial, communal, anti-national,
            objectionable, defamatory, or abusive action or communication.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Harassment, stalking, threats, or other violations of the legal
            rights of others.
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Transmission of inappropriate, profane, defamatory, infringing,
            obscene, indecent, or unlawful content.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Transmission of files that contain viruses, corrupted files, or
            other similar software or programs that may damage or adversely
            affect the operation of another person's computer, Qunions, any
            software, hardware, or telecommunications equipment.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Advertising, offering, or selling any goods or services for any
            commercial purpose on Qunions without the express written consent of
            Qunions.
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Downloading any file, recompiling or disassembling, or otherwise
            affecting Qunions's products that you know or reasonably should know
            cannot be legally obtained in such a manner.
          </span>
        </li>
        <li className="c0 li-bullet-4">
          <span className="c1">
            Falsifying or deleting any author attributions, legal or other
            proper notices, or proprietary designations or labels of the origin
            or the source of software or other material.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Restricting or inhibiting any other user from using and enjoying any
            public area within Qunions's sites.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Collecting or storing personal information about other users.
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Interfering with or disrupting Qunions and/or the Qunions Platform,
            Qunions servers, or Qunions networks.
          </span>
        </li>
        <li className="c0 li-bullet-4">
          <span className="c1">
            Impersonating any person or entity, including but not limited to a
            representative of Qunions, or falsely stating or otherwise
            misrepresenting a user's affiliation with a person or entity.
          </span>
        </li>
        <li className="c0 li-bullet-4">
          <span className="c1">
            Forging headers or manipulating identifiers or other data in order
            to disguise the origin of any content transmitted through Qunions or
            to manipulate a user's presence on Qunions(s).
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Taking any action that imposes an unreasonably or disproportionately
            large load on Qunions's infrastructure.
          </span>
        </li>
        <li className="c0 li-bullet-4">
          <span className="c1">Engaging in any illegal activities.</span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Engaging in any activity that threatens the unity, integrity,
            defense, security, or sovereignty of India, friendly relations with
            foreign states, or public order, or causes incitement to the
            commission of any cognizable offense or prevents investigation of
            any offense or is insulting other nations.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1" start={10}>
        <li className="c7 li-bullet-1">
          <span className="c1">Consequences of Violation:</span>
        </li>
      </ol>
      <p className="c8 c11">
        <span className="c1" />
      </p>
      <ol className="c6 lst-kix_list_2-2" start={16}>
        <li className="c0 li-bullet-2">
          <span className="c1">
            Violation of the user conduct guidelines may result in consequences,
            including but not limited to:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_4-0 start" start={1}>
        <li className="c10 li-bullet-5">
          <span className="c1">
            Suspension or termination of the user account
          </span>
        </li>
        <li className="c10 li-bullet-0">
          <span className="c1">Removal of offending content</span>
        </li>
        <li className="c10 li-bullet-0">
          <span className="c1">
            A temporary or permanent ban from using the app
          </span>
        </li>
        <li className="c10 li-bullet-5">
          <span className="c1">
            Legal action as per applicable laws and regulations
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The app administrators or moderators reserve the right to take
            appropriate actions in response to any violations of the user
            conduct guidelines, as deemed necessary, to ensure the safety and
            integrity of the app and its users.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={4}>
        <li className="c5 li-bullet-0">
          <span className="c2">LIMITATION OF LIABILITY: </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions users are responsible for their own actions and decisions
            when using the Qunions Platform. Qunions is not liable for any
            losses or damages that may occur as a result of using the Qunions
            Platform, including but not limited to personal injury, property
            damage, or financial loss.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            By using the Qunions Platform, users agree to release and indemnify
            Qunions and its affiliates from any and all claims, damages, losses,
            expenses, costs, and liabilities (including attorneys' fees) arising
            out of or in any way connected with their use of the Qunions
            Platform.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions does not guarantee the accuracy or completeness of the
            information provided on the Qunions Platform. Qunions is not liable
            for any errors or omissions in the information provided on the
            Qunions Platform.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Users are responsible for taking all necessary precautions to
            protect themselves from viruses, malware, and other harmful content
            that may be found on the Qunions Platform.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions is not liable for any damages that may occur as a result of
            using the Qunions Platform, including but not limited to computer
            viruses, hardware failures, or software malfunctions.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            If you have any questions about these terms and conditions, please
            contact Qunions at support@qunions.com.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={5}>
        <li className="c5 li-bullet-6">
          <span className="c2">DISCLAIMER:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            We reserve the right to terminate this business model at our
            discretion, upon which the virtual currency in the user's account
            will be converted to real cash prizes at a conversion rate of 5%.
            For example, if a user has Rs 5000 worth of rewards in their
            account, it will be converted to real Rs 250 cash prizes.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions, its parent/holding company, subsidiaries, affiliates,
            directors, officers, professional advisors, and employees shall not
            be held responsible, to the extent permitted by law, for any
            deletion, failure to store, misdelivery, or untimely delivery of
            information or material. Qunions shall also not be responsible for
            any harm resulting from downloading or accessing information or
            material, the quality of servers, products, Qunions Services, or
            sites.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The User acknowledges that any material accessed, downloaded, or
            obtained through the Qunions Platform is at their discretion,
            competence, acceptance, and risk and that they will be solely
            responsible for any potential damage to their computer system or
            loss of data resulting from such downloads.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            While Qunions will make its best efforts to ensure that the Qunions
            Platform is error-free and secure, neither Qunions nor any of its
            partners, licensors, or associates make any warranty regarding the
            fulfillment of the User's requirements, uninterrupted, timely,
            secure, or error-free operation of the Qunions Platform, accuracy or
            reliability of results obtained from its use, or the quality of any
            products, Qunions Services, information, or other material obtained
            through the Qunions Platform meeting User's expectations.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            In the event of Qunions discovering any errors, Qunions reserves the
            right (exercisable at its discretion) to rectify the error in a
            manner it deems fit, including through set-off of the erroneous
            payment from amounts due to the User or deduction from the User's
            account. Qunions agrees to notify the User of the error and the
            exercise of any remedy to rectify it.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            To the extent permitted by law, neither Qunions nor its partners,
            licensors, or associates shall be liable for any direct, indirect,
            incidental, special, or consequential damages arising from the use
            or inability to use the sites, even if they have been advised of the
            possibility of such damages.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Any Qunions Services hosted or provided on the Qunions platform that
            requires specific permission or authority from statutory
            authorities, state or central government, or the board of directors,
            shall be deemed canceled or terminated if such permission or
            authority is not obtained or denied, either before or after the
            availability of the relevant Qunions Services.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            To the extent permitted by law, in the event of suspension or
            closure of any Qunions Services, Users shall not be entitled to make
            any demands or claims of any nature.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions does not guarantee that all aspects of the Service are
            appropriate or available for use in any particular jurisdiction. By
            accessing and using the Service, you acknowledge and agree that:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-2">
          <span className="c1">
            You are accessing and using the Service on your own initiative and
            at your own risk;
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            You will not use the Service if prohibited from receiving products,
            services, or software from the United States;
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            You are responsible for complying with local laws and regulations,
            if applicable;
          </span>
        </li>
        <li className="c0 li-bullet-2">
          <span className="c1">
            You specifically agree to comply with all applicable laws and
            regulations regarding the transmission of technical data from the
            country in which you reside; and
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            If there is a conflict between any terms in this Agreement and your
            rights in your place of residence, your rights under applicable law
            will prevail with respect to those specific terms.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={6}>
        <li className="c5 li-bullet-0">
          <span className="c2">DISCLAIMER OF WARRANTIES: </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Your use of the Service is at your own risk. The Service is provided
            "as is" and "as available" without any warranties of any kind,
            whether express or implied. To the fullest extent permissible under
            applicable law, Qunions disclaims all warranties, express or
            implied, including but not limited to implied warranties of
            merchantability, fitness for a particular purpose, and
            non-infringement. Qunions does not warrant that the Service will be
            available, uninterrupted, secure, or error-free, that defects will
            be corrected, or that the Service or the servers that make the
            Service available are free of viruses or other harmful components.
            Qunions does not warrant or make any representations regarding the
            use or results of the use of the Service, information, software,
            content, or other materials available through the Service or any
            linked website, app, platform, or service, in terms of correctness,
            accuracy, validity, propriety, reliability, legality, security, or
            otherwise. Qunions makes no warranties that your use of the Service,
            information, software, content, or other materials available through
            the Service or any linked website, app, or service will not infringe
            the rights of others. Qunions assumes no liability or responsibility
            for errors or omissions in such services, information, software,
            content, or other materials available through the Service or any
            linked website, app, platform, or service. If applicable law does
            not allow the exclusion of some or all of the above implied
            warranties, the above exclusions will apply to you only to the
            extent permitted by applicable law.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={7}>
        <li className="c5 li-bullet-0">
          <span className="c2">NOTICE:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            When a party is required to provide another party with notice,
            demand, consent, approval, or communication under this Agreement
            (Notice), such Notice must be given through one of the following
            methods: hand delivery, prepaid post, email, or, in the case of
            Qunions issuing a notice, through the Qunions platform to the
            recipient's address for Notices
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={8}>
        <li className="c5 li-bullet-5">
          <span className="c2">TERMINATION:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The Company/Platform reserves the sole and exclusive right to
            unilaterally terminate the User's account immediately in the
            following circumstances:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-3">
          <span className="c1">
            If it is discovered that the User has engaged in activities that
            violate the Terms of Use, Privacy Policy, or any other policies,
            laws, rules, or regulations set forth by governing authorities.
          </span>
        </li>
        <li className="c0 li-bullet-4">
          <span className="c1">
            If the User continues to engage in such activities despite receiving
            notice.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            If the User attempts to manipulate, abuse, distort, or misinterpret
            the Terms of Service, Privacy Policy, or any other policies, laws,
            rules, or regulations set forth by governing authorities for the
            purpose of engaging in unlawful activities.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            If the User harasses, intimidates, provokes, abuses, hurts, or
            participates in any unlawful action against Qunions, the platform,
            and any other individuals associated with Qunions, including
            representatives, agents, and employees.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1" start={2}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            If the User decides to cancel their account, they may do so only
            after ensuring that they have not:
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-2 start" start={1}>
        <li className="c0 li-bullet-4">
          <span className="c1">
            Uploaded, created, or distributed any malicious software, content,
            virus, or destructive algorithm that may cause harm to the Company,
            the Platform, or any other concerned individual/third party.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Violated any provision of the Terms of Service, Privacy Policy, or
            other similar policies, laws, rules, or regulations promulgated by
            governing authorities.
          </span>
        </li>
        <li className="c0 li-bullet-3">
          <span className="c1">
            Once the account is terminated, the Platform/Company shall not grant
            anyone access to the information and shall erase the same within 90
            days from all storage servers and other personalized hardware used
            for the Platform's operation.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={9}>
        <li className="c5 li-bullet-0">
          <span className="c2">INTELLECTUAL PROPERTY RIGHTS:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            All trademarks, service marks, and trade names used by Qunions
            (including, but not limited to, the Qunions name, Qunions corporate
            logo, the Website name, the Website design, and any logos)
            (collectively referred to as "Marks") are either registered or
            unregistered trademarks of Qunions or its affiliates, partners,
            vendors, or licensors. You are not permitted to use, copy,
            reproduce, republish, upload, post, transmit, distribute, or modify
            Qunions trademarks in any way without the prior written consent of
            Qunions, including in advertising or publicity related to the
            distribution of materials on the Website or in the Services.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Without prior written consent, you may not use Qunions' name or any
            language, pictures, or symbols that may imply Qunions' endorsement
            in any written or oral advertising or presentation, brochure,
            newsletter, book, or other written material, as determined by
            Qunions.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Qunions, its licensors, vendors, agents, and/or Content providers
            hold ownership of all the content displayed on the Website or in the
            Services, including text, graphics, photographs, images, moving
            images, sound, and illustrations ("Content"). The Website and
            Services, including the general design and the Content, are
            protected by trade dress, copyright, moral rights, trademark, and
            other intellectual property laws. The use of the Website and
            Services is limited to the intended purpose for which they are made
            available.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            You are not allowed to modify any of the materials on the Website,
            and you may not copy, distribute, transmit, display, perform,
            reproduce, publish, license, create derivative works, transfer, or
            sell any information or work contained on the Website, except as
            permitted by copyright law. Prior permission must be obtained before
            reusing any copyrighted material available on the Website or in the
            Services, as authorized by copyright laws.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            You must comply with all applicable domestic and international laws,
            statutes, ordinances, and regulations when using the Website. Unless
            expressly agreed otherwise, the Website, the Services, its Content,
            and all related rights shall remain the exclusive property of
            Qunions or its licensors.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={10}>
        <li className="c5 li-bullet-5">
          <span className="c2">GOVERNING LAW:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            This Agreement shall be governed by the laws of India and shall be
            subject to the jurisdiction of the courts of Mathura, India.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={11}>
        <li className="c5 li-bullet-0">
          <span className="c2">DISPUTE RESOLUTION:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c4 li-bullet-1">
          <span className="c1">
            In the event of a dispute, disagreement, or difference arising from,
            out of, or in relation to the terms specified in the Terms and
            Conditions (referred to as "Dispute"), Qunions and You (collectively
            referred to as "Parties") shall attempt to resolve such Dispute
            amicably through mediation at the earliest opportunity.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            If mediation fails, the Parties shall resort to arbitration for
            effective and binding dispute resolution. The arbitrators shall be
            chosen jointly within two months.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The arbitration proceedings shall be conducted in English.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The arbitration shall be held in the court of Mathura, India unless
            otherwise specified in the award.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            Unless otherwise specified in the award, both parties shall bear the
            costs of the arbitration, including the fees of the arbitrators,
            equally.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The awards and proceedings shall be carried out in accordance with
            the provisions of the applicable law.
          </span>
        </li>
        <li className="c4 li-bullet-1">
          <span className="c1">
            The award issued jointly by the arbitrators shall be considered
            final.
          </span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-0" start={12}>
        <li className="c5 li-bullet-6">
          <span className="c2">UPDATES:</span>
        </li>
      </ol>
      <ol className="c6 lst-kix_list_2-1 start" start={1}>
        <li className="c7 li-bullet-1">
          <span className="c1">
            Qunions retains the sole discretion to modify these Terms (including
            any applicable Additional Terms) at any time. You acknowledge and
            agree that Qunions may notify you of any changes to the terms or
            policies by posting them on the Service, and that your continued use
            of the Service after such notice constitutes your acceptance of the
            modified terms, which will govern your ongoing use of the Service.
            Therefore, it is your responsibility to review the posted Terms of
            Use and any applicable Additional Terms each time you use the
            Service. Any modifications to these Terms will supersede the prior
            version for all activity occurring after the revised version has
            been made available.
          </span>
        </li>
      </ol>
      <div>
        <p className="c11 c17">
          <span className="c13" />
        </p>
        <p className="c16 c11">
          <span className="c13" />
        </p>
      </div>
    </div>
  );
}
